import { put, call, all, takeLatest, takeEvery } from 'redux-saga/effects';
import services from '../../services';

import {
  GET_IN_APP_NOTIFICATIONS,
  GET_IN_APP_NOTIFICATIONS_SUCCESS,
  GET_IN_APP_NOTIFICATIONS_ERROR,
} from '../types/in-app-notification/get-notifications';

import {
  GET_UNREAD_COUNT,
  GET_UNREAD_COUNT_SUCCESS,
  GET_UNREAD_COUNT_ERROR,
} from '../types/in-app-notification/get-unread-count';

import {
  MARK_NOTIFICATION_READ,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_ERROR,
} from '../types/in-app-notification/mark-as-read';

import {
  MARK_ALL_NOTIFICATIONS_READ,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
} from '../types/in-app-notification/mark-all-as-read';

import { GetInAppNotificationsOutDto } from '../../types/in-app-notification.dto';

function* fetchNotifications({ payload }: { payload: GetInAppNotificationsOutDto & { append?: boolean } }): any {
  try {
    const { response, error } = yield call(services.inAppNotification.getNotifications, payload);

    if (error) {
      yield put({ type: GET_IN_APP_NOTIFICATIONS_ERROR, payload: error });
    } else {
      yield put({ type: GET_IN_APP_NOTIFICATIONS_SUCCESS, payload: response, append: !!payload.append });
    }
  } catch (error) {
    yield put({ type: GET_IN_APP_NOTIFICATIONS_ERROR, payload: 'Error al cargar las notificaciones.' });
  }
}

function* fetchUnreadCount(): any {
  try {
    const { response, error } = yield call(services.inAppNotification.getUnreadCount);

    if (error) {
      yield put({ type: GET_UNREAD_COUNT_ERROR, payload: error });
    } else {
      yield put({ type: GET_UNREAD_COUNT_SUCCESS, payload: response?.unread_count ?? 0 });
    }
  } catch (error) {
    yield put({ type: GET_UNREAD_COUNT_ERROR, payload: 'Error al obtener el conteo.' });
  }
}

function* markAsRead({ payload }: { payload: { id: number } }): any {
  try {
    const { error } = yield call(services.inAppNotification.markAsRead, payload);

    if (error) {
      yield put({ type: MARK_NOTIFICATION_READ_ERROR, payload: error });
    } else {
      yield put({ type: MARK_NOTIFICATION_READ_SUCCESS, payload: { id: payload.id } });
    }
  } catch (error) {
    yield put({ type: MARK_NOTIFICATION_READ_ERROR, payload: 'Error al marcar como leída.' });
  }
}

function* markAllAsRead(): any {
  try {
    const { error } = yield call(services.inAppNotification.markAllAsRead);

    if (error) {
      yield put({ type: MARK_ALL_NOTIFICATIONS_READ_ERROR, payload: error });
    } else {
      yield put({ type: MARK_ALL_NOTIFICATIONS_READ_SUCCESS, payload: null });
    }
  } catch (error) {
    yield put({ type: MARK_ALL_NOTIFICATIONS_READ_ERROR, payload: 'Error al marcar todas como leídas.' });
  }
}

export default function* inAppNotificationSaga() {
  yield takeLatest<any>(GET_IN_APP_NOTIFICATIONS, fetchNotifications);
  yield takeLatest<any>(GET_UNREAD_COUNT, fetchUnreadCount);
  yield takeEvery<any>(MARK_NOTIFICATION_READ, markAsRead);
  yield takeLatest<any>(MARK_ALL_NOTIFICATIONS_READ, markAllAsRead);
}
